import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketCustomReportingExploreController from 'lumen/controllers/market/custom-reporting/explore';
import type { Transition } from 'lumen/services/transition';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import type { ModelFrom } from 'lumen/utils/routes';

type Params = {
  my_explore: string;

  my_model: string;
};

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['business_intelligence.custom_reporting.edit'],
  redirectTo: 'market.custom-reporting.index',
})
export default class MarketCustomReportingExploreRoute extends Route {
  @service('looker-embed-session')
  declare lookerEmbedSession: Services['looker-embed-session'];

  deactivate(): void {
    this.lookerEmbedSession.onSessionExpired = undefined;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model({ my_model: modelName, my_explore: exploreName }: Params) {
    return { modelName, exploreName };
  }

  resetController(controller: MarketCustomReportingExploreController): void {
    void controller.acquireEmbedUrlTask.cancelAll();
    controller.embedError = false;
    controller.embedUrl = undefined;
  }

  setupController(
    controller: MarketCustomReportingExploreController,
    model: ModelFrom<MarketCustomReportingExploreRoute>,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    this.lookerEmbedSession.onSessionExpired = (): void => {
      void controller.acquireEmbedUrlTask.perform();
    };
    void controller.acquireEmbedUrlTask.perform();
  }
}
